/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
/* eslint-disable new-cap */
import { useState } from 'react';
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// import companyServices from '../../../redux/services/companyServices';
import { numGradeToEUgradeEW, levelToCEFR } from '../../../helpers/utils';
import img from '../../../shared/img/logo/logo.png';
import footer from '../../../shared/img/footer.png';
import skillServices from '../../../redux/services/skillServices';

const generatePDF = async (courseInfos, contentTitles, specificSkills) => {
  // const company = await companyServices.getCompanyBygroupId(courseInfos._id);

  const bodyObjectives = [];
  courseInfos.objectives.forEach((objective) => {
    bodyObjectives.push([objective.name]);
  });

  let language = 'FR';

  if (courseInfos.language.name === 'English') {
    language = 'FR';
  } else if (courseInfos.language.name === 'French') {
    language = 'FR';
  } else if (courseInfos.language.name === 'German') {
    language = 'FR';
  } else if (courseInfos.language.name === 'Chinese') {
    language = 'FR';
  } else if (courseInfos.language.name === 'Luxembourgish') {
    language = 'FR';
  } else if (courseInfos.language.name === 'Italian') {
    language = 'FR';
  }

  let grammarLanguage = 'EN';
  if (courseInfos.language.name === 'English') {
    grammarLanguage = 'EN';
  } else if (courseInfos.language.name === 'French') {
    grammarLanguage = 'FR';
  } else if (courseInfos.language.name === 'German') {
    grammarLanguage = 'DE';
  } else if (courseInfos.language.name === 'Chinese') {
    grammarLanguage = 'CH';
  } else if (courseInfos.language.name === 'Luxembourgish') {
    grammarLanguage = 'LU';
  } else if (courseInfos.language.name === 'Italian') {
    grammarLanguage = 'IT';
  }

  const skills = await skillServices.getSkills();
  // const grammarSkills = skills.filter((skill) => skill.type === 'grammar' && skill.level === levelToCEFR(courseInfos.level) && skill[grammarLanguage]?.length > 0);
  const items = [
    { title: 'Entité', body: courseInfos.company.name },
    { title: 'Intitulé de la formation', body: courseInfos.name ? courseInfos.name : 'No name registered' },
    { title: 'Langue et niveau', body: (courseInfos.level || courseInfos.level === 0) && courseInfos.language ? `${courseInfos.language.name} - ${levelToCEFR(courseInfos.level)}` : 'No level chosen' },
    { title: 'Durée', body: courseInfos.coursePlan.duration ? `${courseInfos.coursePlan.duration}h` : 'No duration chosen' },
    { title: 'Date de début', body: courseInfos.coursePlan.beginDate ? moment(courseInfos.coursePlan.beginDate).format('DD/MM/YYYY') : 'No beginning date chosen' },
    { title: 'Date de fin', body: courseInfos.coursePlan.endDate ? moment(courseInfos.coursePlan.endDate).format('DD/MM/YYYY') : 'No ending date chosen' },
    {
      title: 'Formateur',
      body: Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
        ? courseInfos.idTeachers.map((t) => `${t.name} ${t.firstname}`).join(', ')
        : 'No teachers chosen',
    },
  ];

  // formatting skills rows for autoTable
  const bodySkills = [];
  const grammarSkillsArr = [];

  if (contentTitles && contentTitles.length > 0) {
    contentTitles.forEach((contentTitle) => {
      // bodySkills.push([{ content: contentTitle.FR }]);
      contentTitle.formatedContent.forEach((skill, index) => {
        if (skill.categories?.includes('vocPro') && courseInfos.coursePlan?.vocPro) {
          skill.categoriesVoc = courseInfos.coursePlan.vocPro;
        }
        if (skill.categories?.includes('vocInterests') && courseInfos.coursePlan?.vocInterests) {
          skill.categoriesVoc = courseInfos.coursePlan.vocInterests;
        }
        if (skill.categories?.includes('vocWork') && courseInfos.coursePlan?.vocWork) {
          skill.categoriesVoc = courseInfos.coursePlan.vocWork;
        }
        let label = skill.FR;
        if (skill.categoriesVoc) {
          let categories = label;
          skill.categoriesVoc.forEach((elem, indexSkill) => {
            if (indexSkill === skill.categoriesVoc.length - 1) {
              categories += ` ${elem}.`;
            } else {
              categories += ` ${elem},`;
            }
          });
          label = categories;
        }
        if (index === 0) {
          bodySkills.push([
            { content: contentTitle.FR, rowSpan: contentTitle.formatedContent.length },
            { content: label },
          ]);
        } else {
          bodySkills.push([
            { content: label },
          ]);
        }
      });
    });
  }
  if (specificSkills) {
    specificSkills.forEach((specificSkill, index) => {
      // bodySkills.push([{ content: contentTitle.FR }]);
      if (index === 0) {
        bodySkills.push([
          { content: 'Compétences spécifiques', rowSpan: specificSkills.length },
          { content: specificSkill.FR },
        ]);
      } else {
        bodySkills.push([
          { content: specificSkill.FR },
        ]);
      }
    });
  }

  // if (grammarSkills.length > 0
  //   && (courseInfos.language.name === 'French'
  //     || courseInfos.language.name === 'German'
  //     || courseInfos.language.name === 'English'
  //     || courseInfos.language.name === 'Luxembourgish')) {
  //   grammarSkillsArr.push([
  //     { content: '\nGrammaire', colSpan: 2, styles: { fontStyle: 'bold', cellPadding: { bottom: 5 } } },
  //   ]);
  //   grammarSkills.forEach((grammarSkill, index) => {
  //     grammarSkillsArr.push([
  //       { content: grammarSkill[grammarLanguage] },
  //     ]);
  //   });
  // }

  const footSkills = [];
  footSkills.push(
    [{ content: '\nEvaluation et suivi: ', colSpan: 2, styles: { fontStyle: 'bold' } }],
    [{ content: `Contrôle régulier des connaissances et des acquis par des tests effectués par le formateur: ${courseInfos.coursePlan.middleTest ? 'test intermédiaire, ' : ''} ${courseInfos.coursePlan.endTest ? 'test final' : ''}. \nBilan de fin de stage avec niveau et objectifs acquis.`, colSpan: 2 }],
    [{ content: 'Prérequis: ', colSpan: 2, styles: { fontStyle: 'bold' } }],
    [{ content: 'Aucun prérequis n\'est nécessaire pour suivre cette formation. La formation s\'addresse à des personnes disposant d\'un niveau allant de débutant à C2. \nÉvaluation de la formation après 10h et en fin de stage.', colSpan: 2 }],
  );

  // formating students scores
  const bodyStudentScores = [];
  if (courseInfos.listIdUsers && courseInfos.listIdUsers.length > 0) {
    courseInfos.listIdUsers.forEach((student) => {
      bodyStudentScores.push([
        student.name,
        student.firstname,
        student.test?.oralFluency || '',
        student.test?.oralAccuracy || '',
        student.test?.listeningComprehension || '',
        student.test?.writing || '',
        student.test?.readingComprehension || '',
        student.test?.global || '',
        numGradeToEUgradeEW(student?.test?.global || 0),
      ]);
    });
  }
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'letter',
  });

  doc.addImage(img, 'PNG', 210, 20, 40, 30);
  // text is placed using x, y coordinates
  doc.setFontSize(14).text('Plan de développement des compétences', doc.internal.pageSize.getWidth() / 2, 70, { align: 'center' });
  // create a line under heading
  doc.setLineWidth(0.1).line(20, 80, 430, 80);

  // Table for global course plan infos
  autoTable(doc, {
    // columns,
    body: items,
    margin: { left: 20, top: 100 },
    styles: { fontSize: 9 },
    columnStyles: { 0: { fontStyle: 'bold' } },
  });

  // Table for objectives
  autoTable(doc, {
    head: [['Objectifs de la formation: ']],
    body: bodyObjectives,
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
    },
    rowPageBreak: 'avoid',
    styles: { fontSize: 9 },
    margin: { left: 20, top: 20 },
  });

  // Table for scores
  autoTable(doc, {
    head: [
      [{ content: 'Niveaux', colSpan: 9 }],
      [
        { content: 'Nom' },
        { content: 'Prénom' },
        { content: 'Expression orale', colSpan: 2 },
        { content: 'Compréhension orale' },
        { content: 'Expression écrite' },
        { content: 'Compréhension écrite' },
        { content: 'Niveau global', colSpan: 2 },
      ],
      [
        { content: '', colSpan: 2 },
        { content: 'Fluidité' },
        { content: 'Précision' },
        { content: '' },
        { content: 'Test en ligne pour les nouveaux participants', colSpan: 2 },
        { content: 'EW' },
        { content: 'CEFR*' },
      ]],
    body: bodyStudentScores,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
      lineWidth: 0.5,
    },
    bodyStyles: { lineWidth: 0.5 },
    showFoot: 'lastPage',
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  // Table for levels interpretation
  autoTable(doc, {
    head: [
      [{ content: 'Tableau d\'interprétation des niveaux', colSpan: 10 }],
      ['', 'Débutant', 'Elémentaire', 'Pré-intermédiaire', { content: 'Intermédiaire', colSpan: 2 }, 'Avancé', 'Autonome', 'Maîtrise', 'Bilingue']],
    body: [
      ['EW', '0-2', '3', '4', '5', '6', '7', '8', '9', '10'],
      [{ content: 'Conseil de l\'Europe*', rowSpan: 2 }, '', 'A1', 'A2', { content: 'B1', colSpan: 2 }, 'B2', 'C1', 'C2', ''],
      ['Débutant', { content: 'Utilisateur élémentaire', colSpan: 2 }, { content: 'Utilisateur indépendant', colSpan: 3 }, { content: 'Utilisateur expérimenté', colSpan: 2 }, ''],
    ],
    foot: [[{ content: '* Cadre européen commun de référence pour les langues (CECR)', colSpan: 9 }]],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
      lineWidth: 0.5,
    },
    footStyles: {
      halign: 'left',
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 7,
      lineWidth: 0.5,
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    bodyStyles: { lineWidth: 0.5 },
    columnStyles: { 4: { cellWidth: 30 }, 5: { cellWidth: 30 } },
    theme: 'grid',
  });

  // Table for skills
  autoTable(doc, {
    head: [
      [{ content: 'Contenu de la formation', colSpan: 2 }],
      [
        'Catégories', 'Compétences',
      ]],
    body: bodySkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 10,
      lineWidth: 0.5,
      halign: 'center',
    },
    columnStyles: {
      0: { halign: 'center' },
    },
    bodyStyles: { lineWidth: 0.5 },
    footStyles: {
      halign: 'left',
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      // lineWidth: 0.5,
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    showHead: 'firstPage',
    pageBreak: 'avoid',
    theme: 'grid',
  });

  if (grammarSkillsArr.length > 0) {
    autoTable(doc, {
      foot: grammarSkillsArr,
      margin: { left: 23, top: 20 },
      styles: { fontSize: 9, valign: 'middle' },
      columnStyles: {
        0: {
          halign: 'left',
        },
      },
      bodyStyles: { lineWidth: 0.5 },
      footStyles: {
        halign: 'left',
        fillColor: [255, 255, 255],
        textColor: [64, 64, 64],
        // lineWidth: 0.5,
        fontStyle: 'normal',
        cellPadding: { bottom: 0.5 },
      },
      rowPageBreak: 'avoid',
      showHead: 'firstPage',
      pageBreak: 'avoid',
      theme: 'grid',
    });
  }

  autoTable(doc, {
    foot: footSkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle' },
    footStyles: {
      halign: 'left',
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      // lineWidth: 0.5,
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  // Creating footer and saving file
  autoTable(doc, {
    body: [[{ content: '', colSpan: 1 }]],
    styles: {
      fontSize: 7,
      minCellWidth: 300,
      minCellHeight: 110,
      lineWidth: 0,
    },
    bodyStyles: {
      fillColor: [255, 255, 255],
      lineWidth: 0,
    },
    theme: 'grid',
    margin: { left: 20, top: 30 },
    rowPageBreak: 'avoid',
    didDrawCell(data) {
      const textPos = data.cell;
      data.cell.styles.fillColor = [255, 255, 255];
      doc.addImage(footer, textPos.x + 100, textPos.y + 5, 240, 140);
    },
  });

  doc.save('course_plan.pdf');
};

export {
  generatePDF,
};
